import classNames from "classnames";
import React from "react";
import styles from "./listBooleanAction.css";

interface Props {
  isActive: boolean;
  text: string;
  onClick(val: boolean): void;
}
export const ListBooleanAction = ({ isActive, text, onClick }: Props) => {
  return (
    <div
      className={classNames(styles.container, isActive ? styles.active : styles.inactive)}
      onClick={() => onClick(!isActive)}
    >
      {text}
    </div>
  );
};
